export default "__VITE_ASSET__f0b5e4fe__"